export default "__VITE_ASSET__2aa0c219__"